<template>
  <section>
    <div class="heavy" aria-label="Social Media List">
      <slot></slot>
    </div>
    <ul class="grid-x padding-top-xs">
      <li v-for="item in links" :key="item.link" class="icon-24x24">
        <CommonLink :href="item.link" :aria-label="getAriaLabel(item.alt)" :tracking="item.tracking" :class="item.icon" target="_blank">
          <span class="visibility-hidden">{{ getAriaLabel(item.alt) }}</span>
        </CommonLink>
      </li>
    </ul>
  </section>
</template>

<script setup>
import { computed } from 'vue';
import { GET_SOCIAL_LINKS } from '#shared/types/getters';

const navFooter = useNavFooter();
const links = computed(() => navFooter?.[GET_SOCIAL_LINKS] || []);
const getAriaLabel = (alt) => `${alt} - External Website. Opens in a new Window.`; // This is for Accessibility requirements.
</script>

<style scoped lang="scss">
ul {
  gap: map-get($grid-margin-gutters, 'medium');
}
</style>

<style scoped lang="scss" brand="mcom">
label {
  color: $white;
}
</style>
